


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyA6j-k4Y_14qtN__teQvJ5vnS9WaJhK5Ts",
  authDomain: "lenstech-eye-care-hospital.firebaseapp.com",
  projectId: "lenstech-eye-care-hospital",
  storageBucket: "lenstech-eye-care-hospital.firebasestorage.app",
  messagingSenderId: "94694532838",
  appId: "1:94694532838:web:0d6d48bdff97e5ed3cbd27"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export